/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgBatchEdit = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M19.707 1.293 19 .586l-.707.707-8 8-.293.293V14h4.414l.293-.293 8-8L23.414 5l-.707-.707-3-3zM12 12v-1.586l7-7L20.586 5l-7 7H12zm8-.757V16H8V4h4.757l2-2H6v4H2v16h16v-4h4V9.243l-2 2zM6 17v1h10v2H4V8h2v9z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgBatchEdit as BatchEdit };
